/* eslint-disable promise/always-return, promise/catch-or-return */
import { renderPollResult } from './poll.html'
import styles from './poll.module.css'

const STOREAGE_KEY = 'pin-nrkno-poll'

export class Poll extends HTMLElement {
  _interacted = false
  connectedCallback() {
    if (this.pollId === 'done') {
      // All done..
      return false
    }

    this.addEventListener('click', this.onButtonClick, false)

    if (this.hasVoted()) {
      this.getVotes()
    } else {
      this.openVoting()
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onButtonClick, false)
  }

  onButtonClick = async (e) => {
    if (e.target.tagName?.toLowerCase() !== 'button' || !e.target.value) {
      return
    }
    this._interacted = true
    if (e.target.value === 'show-answers') {
      this.getVotes()
    } else {
      this.onVote(e)
    }
  }

  onVote(e) {
    const target = e.target
    const altId = target.value

    if (!altId) {
      return
    }

    // eslint-disable-next-line compat/compat
    fetch(`${this.pollURL}/v1/${this.pollId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        vote: altId,
      }),
    })
      .then((data) => data.json())
      .then((data) => {
        this.setVoted()
        this.showVotes(data, altId)
      })
  }

  openVoting = () => {
    for (let btn of this.buttons) {
      btn.disabled = false
    }
  }

  hasVoted() {
    const pollId = this.pollId
    const storage = JSON.parse(window.localStorage.getItem(STOREAGE_KEY) || '{}')
    return storage[pollId] || false
  }

  setVoted() {
    const storage = JSON.parse(window.localStorage.getItem(STOREAGE_KEY) || '{}')
    storage[this.pollId] = true

    window.localStorage.setItem(STOREAGE_KEY, JSON.stringify(storage))

    return true
  }

  showVotes({ percentage = [], total = 0 } = {}, altId) {
    const alternatives = [...this.alternativeButtons].map((el) => {
      return {
        text: el.innerText,
        value: el.value,
      }
    })
    const question = this.querySelector(`h2 .${styles.question}`).innerText

    this.innerHTML = renderPollResult({ percentage, total, question, alternatives, altId })

    if (this._interacted) {
      this.focusOnResult()
    }
  }

  focusOnResult() {
    const res = this.querySelectorAll(`.${styles.result}:not(.${styles.other})`)
    if (res.length === 1) {
      res?.[0].focus()
    } else {
      this.querySelector(`.${styles.total}`).focus()
    }
  }

  getVotes = () => {
    // eslint-disable-next-line compat/compat
    return fetch(`${this.pollURL}/v1/${this.pollId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((data) => data.json())
      .then((data) => {
        this.showVotes(data)
      })
  }

  get buttons() {
    return this.querySelectorAll('button')
  }

  get alternativeButtons() {
    return this.querySelectorAll('button:not([value="show-answers"])')
  }

  get pollId() {
    return this.getAttribute('poll-id')
  }

  get pollURL() {
    return this.getAttribute('poll-url')
  }
}
